import angular from 'angular'
import outputStatistics from './outputStatistics'
import inputStatistics from './inputStatistics'
import chartAnalysis from './chartAnalysis'

export default angular.module('app.statistics', [outputStatistics, inputStatistics, chartAnalysis])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('statistics', {
            url: '/statistics',
            template: require('views/common/template.html'),
            abstract: true,
            title: '统计报表',
        })
    }]).name



// WEBPACK FOOTER //
// ./src/app/statistics/index.js